import { Controller } from "@hotwired/stimulus"

const YOUTUBE_EMBED_BASE_URL = "https://www.youtube-nocookie.com/embed/"
const YOUTUBE_EMBED_ORIGIN = "https://www.youtube-nocookie.com"

export default class extends Controller {
  static values = {
    videoId: String,
    title: String,
    autoplay: Boolean,
    muted: Boolean,
    scheduledAt: String
  }

  connect() {
    this.startScheduledAutoplayCheck()
  }

  disconnect() {
    clearInterval(this.autoplayTimer)
  }

  mount(event) {
    this.content = event.detail.content

    const autoplay = event.detail.oneTime || this.shouldAutoplay()
    const iframe = this.iframe

    if (iframe) {
      if (autoplay) this.enableAutoplay(iframe)
      return
    }

    const player = document.createElement("iframe")
    player.src = this.embedUrl(autoplay)
    player.title = this.titleValue
    player.className = "size-full"
    player.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    player.allowFullscreen = true
    player.frameBorder = "0"

    this.content.replaceChildren(player)
  }

  startScheduledAutoplayCheck() {
    if (!this.autoplayValue || !this.hasScheduledAtValue) return

    this.autoplayTimer = setInterval(() => this.checkScheduledAutoplay(), 30_000)
    this.checkScheduledAutoplay()
  }

  checkScheduledAutoplay() {
    if (Date.now() < new Date(this.scheduledAtValue).getTime()) return

    if (this.iframe) this.enableAutoplay(this.iframe)
    clearInterval(this.autoplayTimer)
  }

  shouldAutoplay() {
    return this.autoplayValue && (!this.hasScheduledAtValue || Date.now() >= new Date(this.scheduledAtValue).getTime())
  }

  embedUrl(autoplay) {
    const params = new URLSearchParams({ autoplay: autoplay ? "1" : "0", enablejsapi: "1", origin: window.location.origin })
    if (this.mutedValue) params.set("mute", "1")

    return `${YOUTUBE_EMBED_BASE_URL}${this.videoIdValue}?${params}`
  }

  enableAutoplay(iframe) {
    if (new URL(iframe.src).searchParams.get("autoplay") === "1") return

    iframe.contentWindow.postMessage(JSON.stringify({ event: "command", func: "playVideo", args: "" }), YOUTUBE_EMBED_ORIGIN)
  }

  get iframe() {
    return this.content?.querySelector("iframe")
  }
}
